/**
 * Call Controls Slice
 * Manages UI control states
 *
 * NOTE: isMuted and isOnHold are NOT stored here.
 * They are derived from CallSession (single source of truth).
 *
 * NOTE: permissions are NOT stored here.
 * They are derived via selectPermissions selector.
 */
import type { SoftphoneStore } from 'Modules/softphone/store';
import { StateCreator } from 'zustand';
import { CallControlsSlice, CallControlsSliceState } from './index.types';

const initialState: CallControlsSliceState = {
  isVideoActive: false,
  isTransferActive: false,
  isMergeActive: false,
  isMerging: false,
};

export const createCallControlsSlice: StateCreator<
  SoftphoneStore,
  [],
  [],
  CallControlsSlice
> = (
  set,
  get
) => {
  const resetState = { ...initialState };

  return {
    ...initialState,

    // Batch state setter (for syncing with SIP.js in Task 1.2)
    setControlStates: (states) => {
      set((state) => ({ ...state, ...states }));
    },

    toggleVideo: () => {
      set((state) => ({ isVideoActive: !state.isVideoActive }));
    },

    toggleTransfer: () => {
      set((state) => ({ isTransferActive: !state.isTransferActive }));
    },

    cancelTransfer: () => {
      get().resetTransferFlow();
      set({ isTransferActive: false });
    },

    setIsMerging: (isMerging: boolean) => {
      set({ isMerging });
    },

    // Reset
    resetCallControls: () => {
      set(resetState);
      get().resetTransferFlow();
    },
  };
};
